import React, { useContext } from "react";
import Helmet from "react-helmet";
import FlowContext from "../../contexts/flowContext";

const PageTitle = () => {
  const [flowState] = useContext(FlowContext);

  return (
    <React.Fragment>
      <Helmet>
        {flowState.brand && (
          <title>{`${flowState.brand}-${flowState.name}-${flowState.version}`}</title>
        )}
      </Helmet>
    </React.Fragment>
  );
};

export default PageTitle;
